function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero__content">
        <h1 id="hero-title" className="hero__title">
          Registra cada trade con precisión
        </h1>
        <p className="hero__subtitle">
          Bitácora profesional. Controla compras y ventas de
          acciones y opciones, analiza tus estrategias y comparte movimientos solo si tú lo
          decides.
        </p>
        <div className="hero__actions">
          <a href="https://app.ebitrade.com/register" className="btn btn--primary btn--lg">
            Crear cuenta gratis
          </a>
          <a href="#bitacora" className="btn btn--outline btn--lg">
            Ver cómo funciona
          </a>
        </div>
        <p className="hero__note">
          Sin tarjeta de crédito · Datos encriptados · Cancela cuando quieras
        </p>
      </div>

      <div className="hero__visual" aria-hidden="true">
        <div className="hero__phone">
          <div className="hero__phone-notch" />
          <div className="hero__phone-screen">
            <div className="mock-dashboard">
              <div className="mock-dashboard__header">
                <span className="mock-dashboard__label">Portfolio hoy</span>
                <span className="mock-dashboard__pnl mock-dashboard__pnl--up">+$2,847.32</span>
              </div>
              <div className="mock-dashboard__chart">
                <svg viewBox="0 0 240 80" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#258bad" stopOpacity="0.35" />
                      <stop offset="100%" stopColor="#258bad" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M0 60 L30 55 L60 48 L90 52 L120 35 L150 40 L180 22 L210 28 L240 15 L240 80 L0 80 Z"
                    fill="url(#chartFill)"
                  />
                  <path
                    d="M0 60 L30 55 L60 48 L90 52 L120 35 L150 40 L180 22 L210 28 L240 15"
                    fill="none"
                    stroke="#258bad"
                    strokeWidth="2.5"
                  />
                </svg>
              </div>
              <ul className="mock-dashboard__trades">
                <li>
                  <span className="mock-trade__symbol">AAPL</span>
                  <span className="mock-trade__type mock-trade__type--buy">COMPRA</span>
                  <span className="mock-trade__value">+$420</span>
                </li>
                <li>
                  <span className="mock-trade__symbol">SPY 450C</span>
                  <span className="mock-trade__type mock-trade__type--sell">VENTA</span>
                  <span className="mock-trade__value mock-trade__value--down">-$85</span>
                </li>
                <li>
                  <span className="mock-trade__symbol">NVDA</span>
                  <span className="mock-trade__type mock-trade__type--buy">COMPRA</span>
                  <span className="mock-trade__value">+$1,240</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
